import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-location-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfLocationIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @returns
 * @example
 */
export function CcfLocationIcon(props: CcfLocationIconProps) {
  return (
    <SvgIcon {...props} width="30" height="30" viewBox="0 0 30 30" fill="none" >
      <path
        d="M15 15C15.6875 15 16.2762 14.755 16.7663 14.265C17.2563 13.775 17.5008 13.1867 17.5 12.5C17.5 11.8125 17.255 11.2238 16.765 10.7337C16.275 10.2438 15.6867 9.99917 15 10C14.3125 10 13.7238 10.245 13.2337 10.735C12.7438 11.225 12.4992 11.8133 12.5 12.5C12.5 13.1875 12.745 13.7762 13.235 14.2663C13.725 14.7563 14.3133 15.0008 15 15ZM15 27.5C11.6458 24.6458 9.14083 21.995 7.485 19.5475C5.82917 17.1 5.00083 14.8342 5 12.75C5 9.625 6.00542 7.13542 8.01625 5.28125C10.0271 3.42708 12.355 2.5 15 2.5C17.6458 2.5 19.9742 3.42708 21.985 5.28125C23.9958 7.13542 25.0008 9.625 25 12.75C25 14.8333 24.1717 17.0992 22.515 19.5475C20.8583 21.9958 18.3533 24.6467 15 27.5Z"
        fill="#3F5C69"
      />
    </SvgIcon>
  );
}

export default CcfLocationIcon;
